// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4145":"63b26be0","6147":"7045dc20"}[chunkId] + ".chunk.css";
};